// Storage can throw (private windows, blocked site data); every access is guarded
// and the scan card still works without it, just without "already upvoted" memory.
const TOKEN_KEY = 'lh_sidewalk_device';
const VOTED_KEY = 'lh_sidewalk_upvoted';

export function getDeviceToken(): string | null {
  try {
    let token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      token = crypto.randomUUID().replace(/-/g, '');
      localStorage.setItem(TOKEN_KEY, token);
    }
    return token;
  } catch {
    return null;
  }
}

export function pendingSidewalkUpvotes(): number[] {
  try {
    const parsed = JSON.parse(localStorage.getItem(VOTED_KEY) ?? '[]');
    return Array.isArray(parsed) ? parsed.filter((id): id is number => Number.isInteger(id)) : [];
  } catch {
    return [];
  }
}

export const hasSidewalkUpvoted = (displayId: number) => pendingSidewalkUpvotes().includes(displayId);

export function rememberSidewalkUpvote(displayId: number): void {
  try {
    const ids = new Set(pendingSidewalkUpvotes()).add(displayId);
    localStorage.setItem(VOTED_KEY, JSON.stringify([...ids]));
  } catch {
    // Not remembered; the server still dedupes by device.
  }
}

export function clearSidewalkUpvotes(): void {
  try {
    localStorage.removeItem(VOTED_KEY);
  } catch {
    // nothing to clear
  }
}
